<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div *ngIf="!isBottomSheet" class="map-toolbar mat-elevation-z1">
    <mat-toolbar color="primary" class="no-print">
        <section fxLayout="row" fxLayoutAlign="space-between center">
            <ng-container *ngFor="let widget of visibleWidgets$ | async">
                <div style='display:none'>{{ widget | json }}</div>
                <dash-gis-map-toolbar-widget [hotKey]='widget.hotKey'
                                       [commandName]='widget.commandName'
                                       [icon]='widget.icon'
                                       [label]='widget.label'
                                       [isInBottomSheet]='isBottomSheet'
                                       [attributes]='widget.attributes'></dash-gis-map-toolbar-widget>
            </ng-container>
        </section>
    </mat-toolbar>
</div>
<div *ngIf="isBottomSheet" class="map-toolbar-bottomsheet">
    <mat-grid-list [cols]="bottomSheetColumnCount$ | async">
        <mat-grid-tile *ngFor="let widget of visibleWidgets$ | async">
            <div style='display:none'>{{ widget | json }}</div>
            <dash-gis-map-toolbar-widget [hotKey]='widget.hotKey'
                                   [commandName]='widget.commandName'
                                   [icon]='widget.icon'
                                   [label]='widget.label'
                                   [isInBottomSheet]='isBottomSheet'
                                   [attributes]='widget.attributes'
                                   (shouldPreventClose)='handleShouldPreventClose($event)'></dash-gis-map-toolbar-widget>
        </mat-grid-tile>
    </mat-grid-list>
</div>
